export interface SlackUserConstructor {
  id: string
  name: string
  realName: Nullable<string>
  email: Nullable<string>
}

export class SlackUser {
  readonly id: string
  readonly name: string
  readonly realName: Nullable<string>
  readonly email: Nullable<string>

  constructor(data: SlackUserConstructor) {
    this.id = data.id
    this.name = data.name
    this.realName = data.realName
    this.email = data.email
  }

  get displayName(): string {
    return this.realName || this.name
  }

  get hasEmail(): boolean {
    return !!this.email
  }

  get usernameWithAt(): string {
    return `@${this.name}`
  }
}
